import { createSelector, createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RootState } from '../root/root-types';
import { FirebaseTourProgress } from './model';

export const TOUR_FEATURE_KEY = 'tour';

export interface TourState {
  isTourActive: boolean;
  activeChecklistItemIndexDB: number;
  activeChecklistItemIndex: number;
  activeTourModuleIndex: number;
  activeTourTooltipIndex: number;
  tourDataFromFirebase: FirebaseTourProgress[];
  activeModuleIndex: number;
  homePageModal: boolean;
  checklistSidebarCompletionStatus: any;
  showChecklistCompletionModal: 1 | 2 | 3 | 4 | null;

  showInitialTopupModal: boolean;
  showSplashScreenWelcomeModal: boolean;

  infoModal: string | null;
  overlay: boolean;
}

export const TourState: TourState = {
  isTourActive: false,
  activeChecklistItemIndexDB: 0,
  activeChecklistItemIndex: 0,
  activeTourModuleIndex: 0,
  activeTourTooltipIndex: 0,
  tourDataFromFirebase: [],
  activeModuleIndex: 1,
  homePageModal: false,
  checklistSidebarCompletionStatus: {},
  showChecklistCompletionModal: null,
  showInitialTopupModal: true,
  showSplashScreenWelcomeModal: false,
  infoModal: null,
  overlay: false,
};

export const tourChecklistToModuleMap = [
  [1, 2, 3],
  [4, 5, 6],
  [7, 8],
];

export const tourSlice = createSlice({
  name: TOUR_FEATURE_KEY,
  initialState: TourState,
  reducers: {
    updateIsTourActive(state, action: PayloadAction<boolean>) {
      state.isTourActive = action.payload;
    },
    updateActiveChecklistItemIndexDB(state, action: PayloadAction<number>) {
      state.activeChecklistItemIndexDB = action.payload;
    },
    updateActiveChecklistItemIndex(state, action: PayloadAction<number>) {
      state.activeChecklistItemIndex = action.payload;
    },
    updateTourDataFromFirebase(
      state,
      action: PayloadAction<FirebaseTourProgress[]>
    ) {
      state.tourDataFromFirebase = action.payload;
    },

    updateChecklistSidebarCompletionStatus(state, action: PayloadAction<any>) {
      state.checklistSidebarCompletionStatus = action.payload;
    },
    updateActiveTourTooltipIndex(state, action: PayloadAction<number>) {
      state.activeTourTooltipIndex = action.payload;
    },
    updateTourHomePageModal(state, action: PayloadAction<any>) {
      state.homePageModal = action.payload;
    },
    updateShowChecklistCompletionModal(state, action: PayloadAction<any>) {
      state.showChecklistCompletionModal = action.payload;
    },
    updateActiveTourModuleIndex(state, action: PayloadAction<number>) {
      state.activeTourModuleIndex = action.payload;
    },
    updateShowInitialTopupModal(state, action: PayloadAction<boolean>) {
      state.showInitialTopupModal = action.payload;
    },
    updateActiveModuleIndex(state, action: PayloadAction<number>) {
      state.activeModuleIndex = action.payload;
    },
    updateSpashScreenWelcomeModal(state, action: PayloadAction<boolean>) {
      state.showSplashScreenWelcomeModal = action.payload;
    },
    updateInfoModal(state, action: PayloadAction<string | null>) {
      state.infoModal = action.payload;
    },
    updateOverlay(state, action: PayloadAction<boolean>) {
      state.overlay = action.payload;
    },
  },
});

export const {
  updateIsTourActive,
  updateChecklistSidebarCompletionStatus,
  updateActiveTourTooltipIndex,
  updateShowChecklistCompletionModal,
  updateActiveChecklistItemIndexDB,
  updateActiveChecklistItemIndex,
  updateTourDataFromFirebase,
  updateActiveTourModuleIndex,
  updateShowInitialTopupModal,
  updateActiveModuleIndex,
  updateTourHomePageModal,
  updateSpashScreenWelcomeModal,
  updateInfoModal,
  updateOverlay,
} = tourSlice.actions;

export const getTourSliceState = (rootState: RootState): TourState =>
  rootState[TOUR_FEATURE_KEY];

export const getIsTourActive = createSelector(
  getTourSliceState,
  (state) => state.isTourActive
);
export const getTourDataFromFirbase = createSelector(
  getTourSliceState,
  (state) => state.tourDataFromFirebase
);

export const getHomeTourModal = createSelector(
  getTourSliceState,
  (state) => state.homePageModal
);
export const getActiveChecklistItemIndexDB = createSelector(
  getTourSliceState,
  (state) => state.activeChecklistItemIndexDB
);

export const getActiveChecklistItemIndex = createSelector(
  getTourSliceState,
  (state) => state.activeChecklistItemIndex
);

export const getShowChecklistSidebar = createSelector(
  getTourSliceState,
  (state) => false
);
export const getChecklistSidebarCompletionStatus = createSelector(
  getTourSliceState,
  (state) => state.checklistSidebarCompletionStatus
);
export const getActiveTourTooltipIndex = createSelector(
  getTourSliceState,
  (state) => state.activeTourTooltipIndex
);
export const getActiveTourModuleIndex = createSelector(
  getTourSliceState,
  (state) => state.activeTourModuleIndex
);
export const getShowChecklistCompletionModal = createSelector(
  getTourSliceState,
  (state) => state.showChecklistCompletionModal
);
export const getShowInitialTopupModal = createSelector(
  getTourSliceState,
  (state) => state.showInitialTopupModal
);

export const getActiveModuleIndex = createSelector(
  getTourSliceState,
  (state) => state.activeTourModuleIndex
);

export const getSpashScreenWelcomeModal = createSelector(
  getTourSliceState,
  (state) => state.showSplashScreenWelcomeModal
);

export const getInfoModal = createSelector(
  getTourSliceState,
  (state) => state.infoModal
);

export const getOverlay = createSelector(
  getTourSliceState,
  (state) => state.overlay
);
